import React, { Component } from 'react'; 
import { Row, Table, Button, Alert, ModalHeader, Modal,ModalBody, Input} from 'reactstrap';
import Toggle from "react-toggle";
import axios from '../../../../../axios';
import * as url from '../../../../../utils/url';
import findIndex from 'lodash/findIndex';
import CommentsSection from "../CommentsSection/CommentsSection";

import Checkbox from 'rc-checkbox';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; 
import * as actionCreators from '../../../../../modules/actions/index';
import moment from 'moment';
import {groupContentFields, groupPrivacyStatusDesc,uploadPreview,whiteLabelStyling} from  '../../../../../utils/constants';

class EventDiscussion extends Component {

	constructor(props) {
    super(props);
			this.state = { 
				displayComments:[],
        allComments:[],
        menu:this.props.menu
		  }
    }


componentDidMount(){
	this.getAllComments()
}

// componentWillMount() {
//   this.getAllComments()
// }

componentDidUpdate(prevProps,prevState){
  let{menu}=this.props
  console.log('menu----',menu)
  if(menu==2&&menu!=prevProps.menu){
    this.getAllComments()
  }
}


getAllComments = ()=>{
  let{item}=this.props
  axios.get(url.getToolkitComments(item._id)).then(({data}) => {
    if(data.data){
      let { comments } = data.data;
      console.log('comments --- ',  data.data)
      this.setState({
        allComments : comments,
        displayComments : comments.slice(0,2)
      });
    }
  })
}


  handleAddComment = (commentText) => {
    let id = this.props.match.params.id; 
    const {firstName, lastName} = this.props.user;
    const {allComments, displayComments} = this.state;
    const dateTime = moment().toISOString();
    const comment = {date: dateTime,text: commentText,userId: {firstName: firstName, lastName: lastName}};
    allComments.push(comment);
    displayComments.push(comment);
    this.setState({
      allComments : allComments,
      displayComments : displayComments
    });
    axios.post(url.addToolkitComment(id),{text : commentText}).then(({data}) => {
      const comment = data.data;
      const i = findIndex(allComments,{date : dateTime});
      const j = findIndex(displayComments,{date : dateTime});
      allComments.splice(i,1,comment);
      displayComments.splice(j,1,comment);
      this.setState({
        allComments : allComments,
        displayComments : displayComments
      });
    });
  }

  handleDeleteComment = (commentId) => {
    let id = this.props.match.params.id; 
    const {allComments, displayComments} = this.state;
    const i = findIndex(allComments,{_id : commentId});
    allComments.splice(i,1);
    const j = findIndex(displayComments,{_id : commentId});
    displayComments.splice(j,1);
    this.setState({
      allComments : allComments,
      displayComments : displayComments
    })
    axios.delete(url.deleteToolkitComment(id,commentId)).then(({data}) => {
      //do nothing.
    })
  }


  handleSeeMoreComments = () => {
    const { commentPage,allComments,displayComments } = this.state;
    let nextComments = [];
    if(commentPage === 0) {
      nextComments = allComments.slice(0,5);
    } else {
      const start = commentPage * 5;
      nextComments = displayComments.concat(allComments.slice(start,start + 5));
    }
    this.setState({
      displayComments : nextComments,
      commentPage : commentPage + 1
    });
  }

	render() {
        let{item}=this.props
        
        return (<span className="event_details_page_about_section"> 
                 <CommentsSection
                  is_module='EventDiscussion'
                  allComments={this.state.allComments} displayComments={this.state.displayComments} 
                    onAddComment={this.handleAddComment} onDeleteComment={this.handleDeleteComment}
                    onSeeMoreComments={this.handleSeeMoreComments}/>
             </span>)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventDiscussion));


  
  